import React from "react";
import IDEA_GUIDES_LIST from "./index.content";
import Container from "../../common/UI/Container";
import Link from "./Link";
import Item from "./Item";
import "./index.scss";

const STATIC_LIST = IDEA_GUIDES_LIST.map((arg, i) => <Item key={i} i={i} {...arg} />);

const Guides = () => {
  return (
    <section className="PgESM-G">
      <Container mode="standard">
        <h2 className="PgESM-G__title">
          Aprende cómo empezar a vender en Amazon
        </h2>
        <div className="PgESM-G__subtitle">
          Guías y consejos para nuevos vendedores de Amazon
          <Link />
        </div>
        <div className="PgESM-G-list">{STATIC_LIST}</div>
        <Link mobile />
      </Container>
    </section>
  );
};

export default Guides;
